import React from "react";
import { 
    TextField, 
    Button, 
    Paper, 
    Typography, 
    FormControl, 
    InputLabel, 
    Input, 
    CssBaseline, 
    Snackbar
} from '@mui/material'
import RestUtilities from '../../services/RestUtilities';
import Users from '../../models/Users'
import SnackbarWrapper from '../../components/SnackbarWrapper';
import { GrowMessage } from "../../components/GrowMessage";

//const authStyle = require('../../styles/auth.styl')

class ChangePassword extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.confirmPassword = React.createRef()
    }

    state = {
        user: new Users(),
        showMessage: false,
        message: '',
        loading: false
    }

    confirmPassword: React.RefObject<HTMLInputElement>

    fetchUserByPersonalNr = () => {
        let personalNr = window.localStorage.getItem('personalNr')

        RestUtilities.get<Users>(`/api/register?personalNr=${personalNr}`)
            .then(resp => {
                this.setState({ user: resp.content })
            })
    }

    handleChangePassword = (event: any) => {
        const newModel = {...this.state.user}

        newModel.password = event.target.value

        this.setState({ user: newModel })
    }

    handleSubmit = () => {
        if(this.confirmPassword.current.value !== this.state.user.password)
            return

        this.setState({ loading: true })
        RestUtilities.put<Users>('/api/PasswordReser/ChangePassword', this.state.user)
            .then(resp => {
                this.setState({ showMessage: true, loading: false, message: 'Success!' })
            }).catch(resp => {
                this.setState({ showMessage: true, loading: false, message: resp.error_content })
            })
    }

    handleSnackbarClose = (event: any, reason: string) => {
        if (reason === 'clickaway')
            return;

        this.setState({ showMessage: false })
    }

    componentDidMount() {
        this.fetchUserByPersonalNr()
    }

    public render() {
        return (
            <>
                <h2 className='title'>Passwort ändern</h2>
                <main className='main'>
               
                    <Paper className='paper'>
                    <form>
                            <Typography variant='body1'>
                                Passwort Änderung angefordert für <b>{`${this.state.user.firstname} ${this.state.user.lastname} (${this.state.user.email})`}</b>.
    
                                Bitte geben Sie ihr neues Passwort ein.
                            </Typography>
                            <FormControl margin="normal" fullWidth>
                                <InputLabel htmlFor="newPassword">Neues Passwort *</InputLabel>
                                <Input 
                                    id="newPassword" 
                                    name="newPassword" 
                                    autoFocus 
                                    type="password"
                                    onChange={(e:any) => this.handleChangePassword(e)}/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="newPasswordConfirm">Passwort wiederholen *</InputLabel>
                                <Input 
                                    name="newPasswordConfirm" 
                                    type="password" 
                                    id="newPasswordConfirm"
                                    inputRef={this.confirmPassword}/>
                            </FormControl>
                            <CssBaseline />
                            <Button 
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className='btnBlue'
                                onClick={() => this.handleSubmit()}
                            >
                                Speichern
                            </Button>
                            </form>
                        </Paper>     
                     <GrowMessage
                            anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                            message={this.state.message}
                            visible={this.state.showMessage}
                            autoHideDuration={6000}
                            onClose={this.handleSnackbarClose}
                          ></GrowMessage>         
                    {/* <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        open={this.state.showMessage}
                        autoHideDuration={6000}
                        onClose={this.handleSnackbarClose}
                    >
                        <SnackbarWrapper
                            onClose={this.handleSnackbarClose}
                            variant="success"
                            message={this.state.message}
                        />
                    </Snackbar> */}
               
            </main>  
            </>
        )
    }
}

export default ChangePassword